import { connect } from 'react-redux'
import { IGlobalState } from '../../Root/store/appReducer'
import { IDispatchProps, IStateProps, YumAppleSignIn } from './YumAppleSignIn'
import { getWhoAmI } from '../../common/auth/authActions'
import { doAppleSignIn, doAppleSignInFail } from './store/AppleSignInActions'

const mapStateToProps = (state: IGlobalState, { buttonText, isSignUp, disabled }: IStateProps): IStateProps => ({
  buttonText,
  isSignUp,
  disabled,
})

const mapDispatchToProps: IDispatchProps = {
  getWhoAmI,
  doAppleSignIn,
  doAppleSignInFail,
}

export default connect(mapStateToProps, mapDispatchToProps)(YumAppleSignIn)
